import api from "../../index";

export const GetPayrollEmployeeData = ()=> api.post("get-payroll-employee")
export const GetPayrollData = ()=> api.post("get-payroll-data")
export const ViewPayrollHistoryApi = (data)=> api.post("get-payroll-data", data)
export const AddUpdatePayrollEmployee = (data)=> api.post("add-update-payroll-employee",data)
export const AddUpdatePayrollData = (data)=> api.post("add-update-payroll-data",data)
export const DeletePayrollEmployee = (data)=> api.post("delete-payroll-employee",data)
export const DeletePayrollData = (data)=> api.post("delete-payroll-data",data)
export const EmployeePayrollHistory = (data)=> api.post("employee-payroll-history",data)
export const UpdatePayrollEmployeeStatus = (data)=> api.post("update-payroll-employee-status",data)
export const ExportPayrollApi = (data, headers)=> api.post("export-payroll-data", data, headers)
